console.log('CISELES custom.js SIDEBAR FIX v2');

window.addEventListener('scroll', function () {
  var header = document.querySelector('header');
  if (!header) return;

  if (window.scrollY > 25) {
    header.classList.add('scrolled');
  } else {
    header.classList.remove('scrolled');
  }
});


(function () {
  let sidebarAttached = false;
  let closeTimer = null;

  function isTabletOrTouch() {
    return window.matchMedia('(max-width: 1024px)').matches || window.matchMedia('(hover: none)').matches;
  }

  function getSidebarElements() {
    const shopLink =
      document.querySelector('.menu-item-shop > a') ||
      document.querySelector('.menu-item-0 > a') ||
      document.querySelector('a[href="/collections/all"]') ||
      document.querySelector('a[href*="/collections/all"]');

    const shopItem = shopLink ? shopLink.closest('.menu-item-shop, .menu-item-0, li') || shopLink : null;

    const sideMenu =
      document.querySelector('#shop-sidebar') ||
      document.querySelector('.shop-sidebar');

    const overlay =
      document.querySelector('#sidebar-overlay') ||
      document.querySelector('.sidebar-overlay');

    return { shopLink, shopItem, sideMenu, overlay };
  }

  function attachSidebarMenu() {
    const { shopLink, shopItem, sideMenu, overlay } = getSidebarElements();

    if (!shopLink || !shopItem || !sideMenu) {
      console.log('Sidebar v2: waiting for DOM...', {
        shopLink: !!shopLink,
        shopItem: !!shopItem,
        sideMenu: !!sideMenu,
        overlay: !!overlay
      });
      return false;
    }

    if (sidebarAttached) return true;
    sidebarAttached = true;

    console.log('Sidebar v2: attached', {
      shopLink,
      shopItem,
      sideMenu,
      overlay
    });

    function openMenu() {
      clearTimeout(closeTimer);
      sideMenu.classList.add('active');
      shopItem.classList.add('active');

      if (overlay) {
        overlay.classList.add('active');
      }

      document.body.classList.add('shop-sidebar-open');
    }

    function closeMenu() {
      clearTimeout(closeTimer);
      sideMenu.classList.remove('active');
      shopItem.classList.remove('active');

      if (overlay) {
        overlay.classList.remove('active');
      }

      document.body.classList.remove('shop-sidebar-open');
    }

    function delayedClose() {
      clearTimeout(closeTimer);

      closeTimer = setTimeout(function () {
        if (!shopItem.matches(':hover') && !sideMenu.matches(':hover')) {
          closeMenu();
        }
      }, 250);
    }

    // Desktop hover
    shopItem.addEventListener('mouseenter', function () {
      if (isTabletOrTouch()) return;
      openMenu();
    });

    shopItem.addEventListener('mouseleave', function () {
      if (isTabletOrTouch()) return;
      delayedClose();
    });

    sideMenu.addEventListener('mouseenter', function () {
      if (isTabletOrTouch()) return;
      openMenu();
    });

    sideMenu.addEventListener('mouseleave', function () {
      if (isTabletOrTouch()) return;
      delayedClose();
    });

    // Tablet / touch click
    shopLink.addEventListener('click', function (e) {
      if (!isTabletOrTouch()) return;

      e.preventDefault();
      e.stopPropagation();

      if (sideMenu.classList.contains('active')) {
        closeMenu();
      } else {
        openMenu();
      }
    });

    // Do not close when clicking inside sidebar
    sideMenu.addEventListener('click', function (e) {
      e.stopPropagation();
    });

    // Close by overlay
    if (overlay) {
      overlay.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        closeMenu();
      });
    }

    // Close when clicking outside on tablet
    document.addEventListener('click', function (e) {
      if (!isTabletOrTouch()) return;

      if (!shopItem.contains(e.target) && !sideMenu.contains(e.target)) {
        closeMenu();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeMenu();
      }
    });

    return true;
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (!attachSidebarMenu()) {
      const observer = new MutationObserver(function () {
        if (attachSidebarMenu()) {
          observer.disconnect();
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });

      setTimeout(function () {
        observer.disconnect();
      }, 5000);
    }
  });
})();


(function () {
  document.addEventListener(
    'click',
    function (e) {
      const label = e.target.closest('.variant-option__button-label');
      if (!label) return;

      const input = label.querySelector('input[type="radio"]');
      if (!input || input.disabled) return;

      e.stopImmediatePropagation();

      setTimeout(function () {
        location.reload(true);
      }, 50);
    },
    true
  );
})();


document.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector('.variant-picker__form');
  if (!form) return;

  form.style.removeProperty('display');

  const observer = new MutationObserver(function () {
    if (form.style.display === 'none' || form.style.cssText.includes('display: none')) {
      form.style.removeProperty('display');
    }
  });

  observer.observe(form, {
    attributes: true,
    attributeFilter: ['style']
  });
});